import LottoCard from '../LottoCard'
import ThaiLottoCard from '../ThaiLottoCard'
import { LottoCountryCardProps, LottoType } from './LottoCountryCard.types'
import { useThemeAssets } from '../../hooks/useThemeAssets'
import { useTranslation } from 'react-i18next'
import styles from './LottoCountryCard.module.css'

const LottoCountryCard: React.FC<LottoCountryCardProps> = ({
  country,
  flagBackgroundName,
  title,
  date,
  time,
  sections,
  noRound,
  onClick,
  lottoType = LottoType.STOCK,
}) => {
  const isThaiLotto = lottoType === LottoType.THAI
  const { t } = useTranslation()
  const { modelImageUrls, backgroundFlagImageUrls } = useThemeAssets()

  return (
    <div
      className={`lotto-country-card ${styles.card} ${noRound ? styles.noRound : ''}`}
      style={{
        backgroundImage: `url(${backgroundFlagImageUrls[flagBackgroundName]})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
      onClick={onClick}
    >
      {/* Gradient Overlay */}
      <div
        className={`${styles.gradientOverlay} lotto-card-gradient-overlay`}
      />

      {/* Model Image - Hidden for Thai Lotto */}
      {!isThaiLotto && (
        <div className={styles.modelImage}>
          <img
            src={modelImageUrls[country]}
            alt={`${t(title)} Theme`}
            className={`object-contain ${noRound ? styles.noRound : ''}`}
          />
        </div>
      )}

      {/* Card */}
      <div className={styles.cardContent}>
        {isThaiLotto ? (
          <ThaiLottoCard
            country={country}
            flagBackgroundName={flagBackgroundName}
            title={t(title)}
            date={date}
            time={time}
            sections={sections || []}
          />
        ) : (
          <LottoCard
            country={country}
            title={t(title)}
            date={date}
            time={time}
            sections={sections || []}
            noRound={noRound}
          />
        )}
      </div>
    </div>
  )
}

export default LottoCountryCard
